import React, { Component } from "react";
import { Player } from 'video-react';

export default class PageVideo extends Component {
	
	render () {
		
		let block = this.props.block;
				
		if (block) {
			
			if (block.video && block.image) {
			
				const plyrProps = {
					source: 	block.video,
					poster: 	block.image,
					options: 	undefined, 
				}
										
			    return (
				    
				     <div data-id={block.id} className={'c-page__block c-page__block--load-effect c-page__block--space-' + block.space_after + ' c-page__block--' + block.rule_after}>
				    
				    	<div className="l-content l-content--fixed-width">
				    		
				    		<div className="l-grid">
				    		
				    			<div className="l-grid__col">
				    			
				    				<div className="scope-video">
				    				
				    					<Player
											playsInline
											poster={block.image}
											src={block.video}
										/>
				    				
				    				</div>
				    				
				    			</div>
				    			
				    		</div>
				    		
				    	</div>
				    	
				    </div>
				    
				)
			
			} else {
				
				return null;
				
			}
			
		} else {
			
			return null;
		
		}
	}
}
